import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import BioAdmin from 'types/ba/bioAdmin';

export const ContentFragmentServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl + 'ux/content-fragments',
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
	},
});

export default class ContentFragmentService extends ApiService implements BioAdmin.IContentFragmentService {
	constructor() {
        super('bio-admin-assets-service', ContentFragmentServiceAxiosInstance);
    }

	public getContentFragment(fragmentPath: string): AxiosPromise<HTMLDocument> {
		return this.axiosInstance.get('/' + fragmentPath);
	}
}
